<h2 mat-dialog-title>{{ 'admin_single_user.dialog.title' | translate }}</h2>
<p>{{ 'admin_single_user.dialog.descr' | translate: {name: data.name} }}</p>
<mat-dialog-actions align="center" class="dialog-btns">
    <button mat-button (click)="onNoClick()">{{ 'admin_single_user.dialog.cancel' | translate }}</button>
    <button mat-button (click)="deleteUser()" cdkFocusInitial class="dialog-confirm">{{ 'admin_single_user.dialog.ok' | translate }}</button>
</mat-dialog-actions>

<app-loading-overlay [loading]="loading"></app-loading-overlay>